"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
exports.DatePicker = (0, styled_1.default)('div') `
  // 24px of the base spacing - 20px of the .dateInvalidMessage
  margin-bottom: 4px;
  & .SingleDatePickerInput,
  & .SingleDatePickerInput__withBorder,
  & .SingleDatePickerInput .DateInput,
  & .SingleDatePickerInput .DateInput_input {
    background: none;
  }
  & .SingleDatePickerInput {
    &:focus,
    &:focus-visible,
    &:focus-within,
    &:hover {
      border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
        ${(0, ui_theme_1.fromTheme)('color_border_info')};
    }
    .SingleDatePickerInput_calendarIcon {
      > svg {
        fill: ${(0, ui_theme_1.fromTheme)('color_text')};
      }
    }
  }
  & .SingleDatePicker_picker {
    z-index: 1000;
  }

  & .SingleDatePickerInput_calendarIcon {
    color: ${(0, ui_theme_1.fromTheme)('color_link')};
  }

  & .SingleDatePickerInput .DateInput {
    width: auto;

    .DateInput_input {
      padding-left: 0;
      padding-right: 0;
      cursor: pointer;
      text-align: left;
      font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
      font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
    }
    & .DateInput_input,
    & .DateInput_input__focused,
    & .DateInput_input:focus,
    & .DateInput_input:focus-visible,
    & .DateInput_input:focus-within,
    & .DateInput_input:hover {
      border: none;
    }
  }
  .dateInvalidMessage {
    // Make this hidden/visible so it doesn't cause the content to form to jump around.
    visibility: hidden;
    color: ${(0, ui_theme_1.fromTheme)('color_danger')};
    height: 20px;
  }
  &.invalid .SingleDatePickerInput {
    border-color: ${(0, ui_theme_1.fromTheme)('color_border_danger')};
  }
  &.invalid .dateInvalidMessage {
    visibility: unset;
  }
`;
//# sourceMappingURL=styles.js.map